<script setup lang="ts">
const props = defineProps<{
	availability: App.Enums.AvailabilityEnum
}>()
</script>

<template>
	<div
		class="flex items-center gap-1"
		:class="{
			'text-destructive': props.availability === 'back_order'
				|| props.availability === 'discontinued'
				|| props.availability === 'out_of_stock'
				|| props.availability === 'pre_order'
				|| props.availability === 'pre_sale'
				|| props.availability === 'reserved'
				|| props.availability === 'sold_out'
				|| props.availability === 'unknown',
			'text-successful': props.availability === 'in_stock'
				|| props.availability === 'in_store_only'
				|| props.availability === 'limited_availability'
				|| props.availability === 'online_only',
		}"
	>
		<i-ph-package-bold class="size-4" />
		<span>{{ t(`app.availability.${props.availability}`) }}</span>
	</div>
</template>
